import script from "./SuccessStep.vue?vue&type=script&setup=true&lang=js"
export * from "./SuccessStep.vue?vue&type=script&setup=true&lang=js"

import "./SuccessStep.vue?vue&type=style&index=0&id=051463dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-051463dd"]])

export default __exports__